module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABBUAAAAECAYAAADRRAcqAAAAh0lEQVR4nO3aMQqEQBBE0VG888IiGHtql40LC03E4P2wp3kHaGZat+9n3Gs/2eZwOBmHw8k4HE7G4XAyDoeTvc75HxWOGPemk1cOh5NxOJyMw+FkHA4n43A42eucOUaSJEmSJEkXWso3hrtxepwep8fpcXqcHqfH6XF6nB6nx+lxepwnnDH2H3Zfl/z5hZnVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/dotted-line.png
// module id = l4Kk
// module chunks = 1